import store from '@/store/store';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import Messages from '@/assets/ts/utils/Messages';

class OperadorController {
  public static async restringeApenasMarcacaoPG(
    showLoading = true,
  ): Promise<boolean> {
    const route = 'restringeApenasMarcacaoPG';

    const nrOrg: string = store.getters.user.nrorg;
    const cdOperador: string = store.getters.user.cdoperador;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        CDOPERADOR: cdOperador,
      },
    };

    const response = await HttpRequest.post(route, params, showLoading);
    ExpectedError.throwResponseError(response);

    const success: boolean = response.data.dataset.data.success;
    if (!success) {
      throw new Error(Messages.REGISTRO_RESTRICTION_FAIL);
    }

    store.commit('setRestringeRegistro');
    return success;
  }

  public static async verificaFeriasVinculo(
    vinculo: any,
    showLoading = true,
  ): Promise<boolean> {
    const route = 'verificaFeriasVinculo';

    const nrOrg: string = store.getters.user.nrorg;
    const nrvinculom = vinculo.NRVINCULOM;

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        NRORG: nrOrg,
        NRVINCULOM: nrvinculom,
      },
    };

    const response = await HttpRequest.post(route, params, showLoading);
    ExpectedError.throwResponseError(response);

    return response.data.dataset.data[0];
  }

  public static async removeRestricaoApenasMarcacaoPG(
    showLoading = true,
  ): Promise<boolean> {
    const route = 'removeRestricaoApenasMarcacaoPG';

    const nrOrg: string = store.getters.user.nrorg;
    const cdOperador: string = store.getters.user.cdoperador;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        CDOPERADOR: cdOperador,
      },
    };

    const response = await HttpRequest.post(route, params, showLoading);
    ExpectedError.throwResponseError(response);

    const success: boolean = response.data.dataset.data.success;
    if (!success) {
      throw new Error(Messages.REGISTRO_RESTRICTION_CONFIRMATION_FAIL);
    }

    store.commit('unsetRestringeRegistro');
    return success;
  }

}

export default OperadorController;
